import React from 'react';
import Head from 'next/head';
import Redirect from 'components/UtilityComponents/Redirect';
const FurnishedRooms = () => {
  const redirectUrl = '/for-renters'
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Rooms for rent</title>
        <meta
          name="description"
          content="Love where you live and who you live with. Toronto's most innovative renting platform, designed by digital natives for digital natives."
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/winnipeg-soulrooms-pro" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Rooms for rent" />
        <meta
          property="og:description"
          content="Love where you live and who you live with. Toronto's most innovative renting platform, designed by digital natives for digital natives."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Love where you live and who you live with. Toronto's most innovative renting platform, designed by digital natives for digital natives."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/furnished-rooms" />
      </Head>
      <Redirect url={redirectUrl} />
    </div>
  );
};

export default FurnishedRooms;
